import httpClient from '../utils/httpClient';

export const informationService = {

    getInformation: async () => {
        const response = await httpClient.post('/Information/GetInformation');
        return response.data;
    },

    GetApiUrl: async () => {
        const response = await httpClient.get('/Information/GetApiUrl');
        return response.data;
    },

    WaNumber: async () => {
        try {
            const data = await httpClient.get('/WhatsApp/whatsapp-number');
            
            if (data.data?.number) {
                //console.log("Saved WhatsApp Number:", data.number);
                localStorage.setItem("salesPersonWA", data.data.number);
            }

        } catch (e) {
            console.error("Error fetching WA number:", e);
        }

    },

    TestCoros: async () => {
        const response = await httpClient.get('/Information/test-cors');
        return response.data;

    }
}